<template>
    <div class="backTop" @click="backtop">

    </div>
</template>
<script>
export default {
    name: "BackTop",
    setup(props,{emit}){
        return{
            backtop:()=>{
                emit('bTop')
            }
        }
    }
}
</script>
<style scoped>
    .backTop{
        width: 48px;
        height: 48px;
        position: fixed;
        background: #FCFCFC url('~assets/images/up.png') no-repeat center;
        bottom: 80px;
        right: 10px;
        z-index: 20px;
        box-shadow: 5px 5px 5px #888888;
        border-radius: 50%;
    }
</style>
